import {
  mutationNames
} from '@/store/storeKeysettings'
import {
  convertBoolean,
  IsDevSim
} from '@/modules/helper/index'
import { ConstPaths } from '@/config/pathConfig'
import { Get, Post } from '@/modules/wrapper/apiWrapper'
import appconfig from '@/store/modules/appconfig'
import * as Helper from '@/modules/helper/index'

const defaultChatData = {
  Parent: {
    'Id': '',
    'PageTitle': '',
    'RowCreated': null,
    'RowUpdated': null,
    'SubscriptionModule_Id': 0,
    'HeaderElements': '',
    'FooterElements': ''
  },
  'ChatsChannels': []
}
const state = {
  Chat: Object.assign({}, defaultChatData),
  ChatsUser: {
    'id': '',
    'rowCreated': '',
    'rowUpdated': '',
    'rowDeleted': false,
    'subscriptionId': 0,
    'deviceId': '',
    'userName': '',
    'userEmail': '',
    'userImage': '',
    'banned': false,
    'blocked': false
  },
  Connection: null,
  ConnectionList: [],
  ChatHistory: [],
  ChannelmsgCount: Helper.ChannelmsgCount.get() || [],
  TypingUsers: [],
  Messagenode: null,
  ActiveChannelId: '',
  IsRegistred: false,
  NewChatChannel: null,
  IsReconnecting: false,
  messageEditing: {
    isEditingOn: false,
    message: '',
    messageId: '',
    channelId: '',
    messageElm: null
  },
  isScrollMessages: true,
  isEditMessageViewPortOn: false,
  messageTypers: {name: '', avatar: ''}
}

const mutations = {
  [mutationNames.SET_CHAT](state, payload) {
    state.Chat = payload
  }, 
  [mutationNames.SET_CHAT_PARENT](state, payload) {
    state.Chat.Parent = payload
  }, 
  [mutationNames.SET_CHAT_CHANNELS](state, ChatsChannels) {
    state.Chat.ChatsChannels = ChatsChannels
  },
  [mutationNames.SET_CHAT_USER](state, ChatsUser) {
    state.ChatsUser = ChatsUser
  },
  [mutationNames.UPDATE_CHAT_USER_INFO](state, payload) {
    state.ChatsUser = Object.assign({}, state.ChatsUser, payload)
  },
  [mutationNames.SET_CHAT_CONNECTION](state, payload) {
    state.Connection = payload
  },
  [mutationNames.SET_CHAT_CONNECTIONS](state, payload) {
    state.ConnectionList = payload
  },
  [mutationNames.SET_CHAT_HISTORY](state, payload) {
    state.ChatHistory = payload
  },
  [mutationNames.SET_CHANNEL_MESSAGE_COUNT](state, payload) {
    state.ChannelmsgCount = payload
  },
  [mutationNames.SET_TYPING_USERS](state, payload) {
    state.TypingUsers = payload
  },
  [mutationNames.SET_MESSAGE_NODE](state, payload) {
    state.Messagenode = payload
  },
  [mutationNames.SET_ACTIVE_CHANNEL_ID](state, payload) {
    state.ActiveChannelId = payload
  },
  [mutationNames.CREATE_NEW_CHAT_CHANNEL](state, payload) {
    state.NewChatChannel = payload
  },
  [mutationNames.RESET_RECONNECTING_FLAG](state, payload) {
    state.IsReconnecting = payload
  },
  manageMessageEditing (state, payload) {
    state.messageEditing = payload
  },
  setResetScrollMessageFlag (state, payload) {
    state.isScrollMessages = payload
  },
  setResetEditMessageViewPortFlag (state, payload) {
    state.isEditMessageViewPortOn = payload
  },
  setResetMessageTypers (state, payload) {
    state.messageTypers = payload
  }
}

const actions = {
  initChatData: ({
    commit
  }, payload) => {
    commit(mutationNames.SET_CHAT_PARENT, payload)
  },
  setUserInfo({
    commit
  }, payload) {
    commit(mutationNames.SET_CHAT_USER, payload)
  },
  updateUserData: ({
    commit
  }, payload) => {
    commit(mutationNames.UPDATE_CHAT_USER_INFO, payload)
  },
  setConnection: ({
    commit
  }, payload) => {
    commit(mutationNames.SET_CHAT_CONNECTION, payload)
  },
  setConnections: ({
    commit
  }, payload) => {
    commit(mutationNames.SET_CHAT_CONNECTIONS, payload)
  },
  setChannelmsgCount: ({
    commit
  }, payload) => {
    Helper.ChannelmsgCount.set(payload)
    commit(mutationNames.SET_CHANNEL_MESSAGE_COUNT, payload)
  },
  setTypingUsers: ({
    commit
  }, payload) => {
    commit(mutationNames.SET_TYPING_USERS, payload)
  },
  setMessagenode: ({
    commit
  }, payload) => {
    commit(mutationNames.SET_MESSAGE_NODE, payload)
  },  
  setActiveChannelId: ({
    commit
  }, payload) => {
    commit(mutationNames.SET_ACTIVE_CHANNEL_ID, payload)
  },
  updatChatHistory({ commit }, payload) {
    commit(mutationNames.SET_CHAT_HISTORY, payload)
  },  
  async getUserInfo({ state, commit }, chatUserId) {
    return await Get(`${ConstPaths.chatApiUrl}ModulesChatsUsers/${chatUserId.toUpperCase()}`)
  },  
  async getChannelList({ state, commit }, payload) {
    let response = await Get(`${ConstPaths.chatApiUrl}ModulesChatsChannels/GetModulesChannels/${payload.Id.toUpperCase()}/${payload.SubscriptionModuleId}`)
    commit(mutationNames.SET_CHAT_CHANNELS, response)
    return response
  },
  async getChannelMessages({ state, commit }, payload) {
    return await Get(`${ConstPaths.chatApiUrl}ModulesChatsChannelsMessages/${payload.ChannelId.toUpperCase()}/${payload.UserId}/${payload.DateTime}`)
  },
  async getChannelMessageByCount({ state, commit }, payload) {
    return await Get(`${ConstPaths.chatApiUrl}ModulesChatsChannelsMessages/GetMessagesbyCount/${payload.channelId.toUpperCase()}/${payload.startMessageCount}/${payload.totalMessageCount}/${payload.userId}`)
  },
  async insertUser({state, commit}, payload) {
    return await Post(`${ConstPaths.chatApiUrl}ModulesChatsUsers/InsertUser`, payload)
  },
  async resetChat({state, commit}) {
    return await commit(mutationNames.SET_CHAT_PARENT, Object.assign({}, defaultChatData))
  },
  async resetChatHistory({state, commit}) {
    return await commit(mutationNames.SET_CHAT_HISTORY, [])
  },
  async resetChatData({state, commit}) {
    await commit(mutationNames.SET_CHAT_PARENT, Object.assign({}, defaultChatData.Parent))
    await commit(mutationNames.SET_CHAT_CHANNELS, defaultChatData.ChatsChannels)
    await commit(mutationNames.SET_CHAT_HISTORY, [])
    return
  },
  async galleysImageUpload({state, commit}, payload) {
    return await Post(`${appconfig.state.AppConfig.Urls.WebAPIURL}/api/ImageServices/GalleysUpload`, payload)
  },
  async galleyImageUpload({state, commit}, payload) {
    return await Post(`${appconfig.state.AppConfig.Urls.WebAPIURL}/api/ImageServices/GalleyUpload`, payload)
  },
  async getUserInfoByDeviceId({ state, commit }, deviceId) {
    return await Get(`${ConstPaths.chatApiUrl}ModulesChatsUsers/GetChatUserbydeviceId/${deviceId}`)
  },
  async checkEmailExists({ state, commit }, payload) {
    return await Post(`${ConstPaths.chatApiUrl}ModulesChatsUsers/Emailvarification`, payload)
  },
  async updateUser({ state, commit }, payload) {
    return await Post(`${ConstPaths.chatApiUrl}ModulesChatsUsers/UpdateUser`, payload)
  },
  async getVerificationCode({ state, commit }, payload) {
    return await Post(`${ConstPaths.chatApiUrl}ModulesChatsUsers/GetVerificationCode`, payload)
  },
  async setResetReconnectingFlag({state, commit}, payload) {
    commit(mutationNames.RESET_RECONNECTING_FLAG, payload)
  },
  async manageMessageEditing({state, commit}, payload) {
    commit('manageMessageEditing', payload)
  },
  async setResetScrollMessageFlag({state, commit}, payload) {
    commit('setResetScrollMessageFlag', payload)
  },
  async setResetEditMessageViewPortFlag({state, commit}, payload) {
    commit('setResetEditMessageViewPortFlag', payload)
  },
  async setResetMessageTypers({state, commit}, payload) {
    commit('setResetMessageTypers', payload)
  }
}

const getters = {
  Chat: state => state.Chat,
  ChatParent: state => state.Chat.Parent,
  ChatsChannels: state => state.Chat.ChatsChannels,
  ChatsUser: state => state.ChatsUser,
  Connection: state => state.Connection,
  ChannelmsgCount: state => state.ChannelmsgCount,
  TypingUsers: state => state.TypingUsers,
  Messagenode: state => state.Messagenode,
  ActiveChannelId: state => state.ActiveChannelId,
  ChatHistory: state => state.ChatHistory,
  ConnectionList: state => state.ConnectionList,
  NewChatChannel: state => state.NewChatChannel,
  IsRegistred: state => state.IsRegistred,
  IsReconnecting: state => state.IsReconnecting,
  getMessageEditingObj: state => state.messageEditing,
  isScrollMessages: state => state.isScrollMessages,
  isEditMessageViewPortOn: state => state.isEditMessageViewPortOn,
  messageTypers: state => state.messageTypers
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/chat.js